import $ from "jquery";
import bdjs from "@bd-core/bdjs";
import CONFIG from "@bd-core/config";
import bdapi from "@bd-core/bd-api";
import { goAsync } from "@bd-utils/goAsync";
import Store_GameSession from "@bd-components/store-game-session";

export const WelcomePage = () => {
  const isWelcomePage = $("#page-welcome").length > 0;
  if (!isWelcomePage) return false;

  if (Store_GameSession.isValid() && CONFIG.GP) {
    bdjs.showLoading(() => {
      window.location.href = CONFIG.siteURL + bdjs.suffixURL();
    }, true);
    return false;
  }

  bdjs.hideLoading();

  const elms = {
    submit: ".js-submit-login",
    inputCode: ".js-input-code",
    codeWrapper: ".welcome__codeForm",
    codeError: ".welcome__codeError",
  };

  let codeBuffer = ["", "", "", ""];
  let activeCursorIndex = 0;

  const updateCodeSlots = () => {
    const isFocused = $(elms.inputCode).is(":focus");

    $(".js-code-slots .welcome-lock-card__code-slot").each(function (index) {
      const $slot = $(this);
      const $char = $slot.find(".welcome-lock-card__code-char");

      $slot.removeClass("is-filled is-active");

      const charVal = codeBuffer[index] || "";
      if (charVal !== "") {
        $char.text(charVal);
        $slot.addClass("is-filled");
      } else {
        $char.text("");
      }

      // Highlight the slot currently being targeted for edit
      if (index === activeCursorIndex && isFocused) {
        $slot.addClass("is-active");
      }
    });

    const isComplete = codeBuffer.every(c => c !== "");
    $(elms.submit).prop("disabled", !isComplete);
  };

  const onInputCode = function () {
    let val = $(this).val().replace(/\D/g, ""); // Restrict to numbers only
    if (val.length > 4) {
      val = val.substring(0, 4);
    }
    $(this).val(val);

    // Fallback/Autofill synchronization
    for (let i = 0; i < 4; i++) {
      codeBuffer[i] = val[i] || "";
    }
    
    // Position cursor to first empty slot, or 3 if full
    let firstEmpty = codeBuffer.indexOf("");
    activeCursorIndex = firstEmpty === -1 ? 3 : firstEmpty;

    $(".gameOptions").removeClass("is-join-error");
    updateCodeSlots();
  };

  const loginUsingCode = async () => {
    const $loginBtn = $(elms.submit);
    const $inputCode = $(elms.inputCode);
    const $codeWrapper = $(elms.codeWrapper);
    const $gameOptions = $(".gameOptions");

    if ($loginBtn.hasClass("is-loading")) return;

    $loginBtn.addClass("is-loading");
    $codeWrapper.removeClass("is-error");
    $gameOptions.removeClass("is-join-error");

    const { data: response, err } = await goAsync(
      bdapi.post("public/login", {
        code: $inputCode.val(),
      }),
    );

    $loginBtn.removeClass("is-loading");

    const restData = response?.data || {};
    const restMessage =
      restData?.data?.message || "Something went wrong. Please try again!";
    const isCodeInvalid = restData?.data?.invalidCode || false;

    if (isCodeInvalid) {
      $codeWrapper.addClass("is-error");
      $gameOptions.addClass("is-join-error");
    }

    if (err || !restData?.success) {
      $codeWrapper.addClass("is-error");
      $gameOptions.addClass("is-join-error");
      return;
    }

    $gameOptions.addClass("is-success");

    const gpId = restData?.data?.gp_id;
    const teamCode = restData?.data?.team_code;
    if (gpId && teamCode) {
      Store_GameSession.save(gpId, teamCode);
    }

    bdjs.showLoading(() => {
      const redirect = restData?.data?.redirect || CONFIG.siteURL;
      window.location.href = redirect + bdjs.suffixURL();
    }, true);
  };

  // Auto-focus and keyboard input helpers
  const $input = $(elms.inputCode);

  // Focus input initially
  $input.focus();

  // Handle slot clicking to set the active cursor position
  $(".js-code-slots").on("click", ".welcome-lock-card__code-slot", function (e) {
    e.stopPropagation();
    const idx = parseInt($(this).attr("data-index"), 10);
    activeCursorIndex = idx;
    $input.focus();
    updateCodeSlots();
  });

  // Refocus input on click to ensure typing remains active
  $(document).on("click", function (e) {
    const isErrorActive = $(".gameOptions").hasClass("is-join-error");
    const isSuccessActive = $(".gameOptions").hasClass("is-success");
    const isCloseBtn = $(e.target).closest(".js-close-error").length > 0;
    const isSlotClick = $(e.target).closest(".welcome-lock-card__code-slot").length > 0;
    
    if (!isErrorActive && !isSuccessActive && !isCloseBtn && !isSlotClick) {
      let firstEmpty = codeBuffer.indexOf("");
      activeCursorIndex = firstEmpty === -1 ? 3 : firstEmpty;
      $input.focus();
      updateCodeSlots();
    }
  });

  // Global keydown listeners for entering characters from ANYWHERE on the page
  $(document).on("keydown", function (e) {
    const isErrorActive = $(".gameOptions").hasClass("is-join-error");
    const isSuccessActive = $(".gameOptions").hasClass("is-success");

    // Do not intercept if success page is loading
    if (isSuccessActive) return;

    // Handle error dialog keys
    if (isErrorActive) {
      if (e.key === "Enter" || e.key === "Escape") {
        e.preventDefault();
        $(".js-close-error").trigger("click");
      }
      return;
    }

    // Handle backspace globally
    if (e.key === "Backspace") {
      e.preventDefault();
      if (codeBuffer[activeCursorIndex] !== "") {
        codeBuffer[activeCursorIndex] = "";
      } else if (activeCursorIndex > 0) {
        activeCursorIndex--;
        codeBuffer[activeCursorIndex] = "";
      }
      $input.val(codeBuffer.join(""));
      updateCodeSlots();
      return;
    }

    // Handle Enter globally
    if (e.key === "Enter") {
      const isComplete = codeBuffer.every(c => c !== "");
      if (isComplete) {
        e.preventDefault();
        $(elms.submit).trigger("click");
      }
      return;
    }

    // Handle numeric key entry (0-9)
    if (/^[0-9]$/.test(e.key)) {
      e.preventDefault();
      codeBuffer[activeCursorIndex] = e.key;
      if (activeCursorIndex < 3) {
        activeCursorIndex++;
      }
      $input.val(codeBuffer.join(""));
      updateCodeSlots();
    }
  });

  $(elms.inputCode).on("input", onInputCode);
  $(elms.inputCode).on("focus blur", updateCodeSlots);
  $(elms.submit).on("click", loginUsingCode);

  $(".js-close-error").on("click", function (e) {
    e.preventDefault();
    $(".gameOptions").removeClass("is-join-error");
    codeBuffer = ["", "", "", ""];
    activeCursorIndex = 0;
    $input.val("");
    updateCodeSlots();
    setTimeout(() => {
      $input.focus();
    }, 50);
  });

  // Initialize Slots
  updateCodeSlots();
};
